<template>
  <!--doctype html-->
  <html>
    <head>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
    </head>
    <body>
      <div id="app" class="container-fluid">
        <div v-if="isLoading">Loading...</div>
        <div v-else>
          <Nav v-on:locale-change="loadLocaleMessages" v-if="showNav"></Nav>
          <router-view />
          <FlashMessage :position="'left bottom'"></FlashMessage>
        </div>
      </div>
    </body>
  </html>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Nav from "@/components/Nav";
import {
  setDocumentDirectionPerLocale,
  setDocumentTitle,
  setDocumentLang
} from "@/util/i18n/document";
import { loadLocaleMessagesAsync } from "@/i18n";
export default {
  created: function() {
    console.log("Created comp");
  },
  data() {
    return {
      isLoading: true
    };
  },
  components: {
    Nav
  },
  mounted() {
    this.loadLocaleMessages(this.$i18n.locale);
    this.listenForCards;
  },
  methods: {
    loadLocaleMessages(locale) {
      this.isLoading = true;
      loadLocaleMessagesAsync(locale).then(() => {
        this.$moment.locale(locale);
        setDocumentLang(locale);
        setDocumentDirectionPerLocale(locale);
        setDocumentTitle(this.$t("app.title"));
        this.isLoading = false;
      });
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    ...mapActions(["listenForCards"]),
    showNav() {
      return true;
      //return Object.keys(this.userProfile).length > 1;
    }
  }
};
</script>
<style>
.bg-theme {
  background-color: hotpink;
}
</style>
